import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Pricing() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      {/* Header */}
      <header className="bg-black/20 backdrop-blur-sm border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button onClick={() => navigate('/')} className="text-white/60 hover:text-white transition-colors">
                ← Back
              </button>
              <div className="flex items-center space-x-3">
                <img src="/veritascore-logo.png" alt="VeritasCore" className="h-10 w-10" />
                <div>
                  <h1 className="text-2xl font-bold text-white tracking-tight">VERITASCORE.IO</h1>
                  <p className="text-xs text-gray-400">Truth. Verified. Scored.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Pricing Section */}
      <div className="max-w-4xl mx-auto px-6 py-20">
        
        {/* Headline */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-white mb-6">
            Get a Verified Case File Before Intake
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Complete credibility analysis, verified evidence, and structured statements—delivered before you ever talk to the client.
          </p>
        </div>

        {/* Main Pricing Box */}
        <div className="bg-gradient-to-br from-teal-500/10 to-blue-500/10 border-2 border-teal-500/30 rounded-3xl p-12 mb-12">
          
          {/* Product Name */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center space-x-3 bg-teal-500/20 rounded-full px-6 py-2 mb-4">
              <img src="/veritascore-logo.png" alt="VeritasCore" className="h-6 w-6" />
              <span className="text-teal-300 font-bold text-lg">VeritasCore™ Report</span>
            </div>
          </div>

          {/* Price */}
          <div className="text-center mb-10 pb-10 border-b border-white/10">
            <div className="text-7xl font-bold text-white mb-2">$299</div>
            <div className="text-xl text-gray-400">per case</div>
          </div>

          {/* What's Included */}
          <div className="space-y-5 mb-10">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center mt-1">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <div className="text-white font-semibold text-lg mb-1">Structured Statement</div>
                <p className="text-gray-400 text-sm">AI-organized narrative with timestamp verification and consistency analysis</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center mt-1">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <div className="text-white font-semibold text-lg mb-1">Verified Evidence</div>
                <p className="text-gray-400 text-sm">GPS-stamped photos, location data, and timestamped documentation</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center mt-1">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <div className="text-white font-semibold text-lg mb-1">Veritas Score™ (0-100)</div>
                <p className="text-gray-400 text-sm">AI-powered credibility assessment with transparent, explainable methodology</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center mt-1">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <div className="text-white font-semibold text-lg mb-1">Complete Analysis Report</div>
                <p className="text-gray-400 text-sm">Professional report with consistency analysis, key findings, and recommended next steps</p>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="text-center">
            <button
              onClick={() => navigate('/claimvoice')}
              className="bg-teal-500 hover:bg-teal-600 text-white px-12 py-5 rounded-xl font-bold text-xl transition-all inline-flex items-center space-x-3 shadow-lg shadow-teal-500/50"
              data-testid="generate-report-btn"
            >
              <span>Generate Your First Report</span>
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </button>
            <p className="text-sm text-gray-500 mt-4">Start with ClaimVoice to create your first verified case file</p>
          </div>

        </div>

        {/* Secondary Info */}
        <div className="text-center">
          <p className="text-sm text-gray-500">
            Individual components available for enterprise clients. <a href="mailto:contact@veritascore.io" className="text-teal-400 hover:text-teal-300">Contact us</a> for volume pricing.
          </p>
        </div>

        {/* Value Props */}
        <div className="grid md:grid-cols-3 gap-8 mt-16 pt-16 border-t border-white/10">
          <div className="text-center">
            <div className="text-4xl mb-3">⚡</div>
            <h3 className="text-white font-bold mb-2">Minutes, Not Hours</h3>
            <p className="text-gray-400 text-sm">Get verified case files before intake—no manual verification needed</p>
          </div>
          <div className="text-center">
            <div className="text-4xl mb-3">🎯</div>
            <h3 className="text-white font-bold mb-2">Know Before You Commit</h3>
            <p className="text-gray-400 text-sm">Credibility scores help you prioritize high-value cases</p>
          </div>
          <div className="text-center">
            <div className="text-4xl mb-3">📊</div>
            <h3 className="text-white font-bold mb-2">Explainable AI</h3>
            <p className="text-gray-400 text-sm">Every score includes detailed reasoning—no black box</p>
          </div>
        </div>

      </div>
    </div>
  );
}
